import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { FadeInSection } from '@/hooks/useAnimation';

export default function ArticleRecommend() {
  const featuredArticles = articles.slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <FadeInSection>
          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-12 gap-4">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
                瓜果知识分享
              </h2>
              <p className="text-sm md:text-base text-foreground-500">
                挑选技巧、营养知识、创意食谱，关于瓜果的一切都在这里
              </p>
            </div>
            <Link
              to="/category?tab=articles"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </FadeInSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article, index) => (
            <FadeInSection key={article.id} delay={index * 150} direction="up">
              <Link
                to={`/article/${article.id}`}
                className="group bg-background-50 rounded-2xl border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer block"
              >
                <div className="aspect-[16/10] overflow-hidden bg-background-100">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-50 text-accent-700">
                      {article.category}
                    </span>
                    <span className="text-xs text-foreground-400">{article.readTime}阅读</span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                    {article.summary}
                  </p>
                  <div className="flex items-center gap-2 mt-4 pt-3 border-t border-background-100">
                    <span className="text-xs text-foreground-400">{article.author}</span>
                    <span className="text-xs text-foreground-300">·</span>
                    <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  </div>
                </div>
              </Link>
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
}